import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { styles } from './about-styles';
import { styles as sharedStyles } from '../../styles/shared-styles';
import '@shoelace-style/shoelace/dist/components/card/card.js';
import '@shoelace-style/shoelace/dist/components/tab-group/tab-group.js';
import '@shoelace-style/shoelace/dist/components/tab/tab.js';
import '@shoelace-style/shoelace/dist/components/tab-panel/tab-panel.js';
import { WithUserProfileConsumer } from '../../mixins/with-user-profile-consumer';
import { markdown } from '../../utility/markdown';
import { appVersion } from '../../utility/app-version';

@customElement('app-about')
export class AppAbout extends WithUserProfileConsumer(LitElement) {
  static styles = [sharedStyles, styles];

  render() {
    const text = markdown`
      # About {{app displayName}}

      Welcome to {{app displayName}}, a comprehensive platform designed to empower our {{term member.lowerPlural}} with cutting-edge tools and resources. At {{app displayName}}, we believe in fostering innovation, collaboration, and growth. Our suite offers a seamless blend of technology and user-centric design, ensuring that every interaction is intuitive and impactful.

      With {{app displayName}}, you gain access to a rich ecosystem of features tailored to meet your unique needs. Whether you're managing projects, enhancing productivity, or connecting with a vibrant community of like-minded individuals, {{app displayName}} is here to support your journey every step of the way.

      Experience the benefits of streamlined workflows, enhanced communication, and unparalleled support. Join us in shaping a future where possibilities are limitless, and success is within reach for everyone. Together, we can achieve greatness.

      Discover the {{app displayName}} difference today and unlock your full potential!
    `;

    const terms = markdown`
      # Terms and Conditions

      By using {{app displayName}}, you agree to abide by all applicable laws and regulations, and to respect the rights and privacy of other {{term loginUser.lowerPlural}}. Unauthorized use, distribution, or duplication of any content or features is strictly prohibited.

      {{app displayName}} reserves the right to modify or discontinue any aspect of the service at any time. Continued use of the platform constitutes acceptance of any changes to these terms.

      For full details, please refer to our official Terms and Conditions documentation or contact support.
    `;

    return html`
      <sl-tab-group>
        <sl-tab slot="nav" panel="english">About</sl-tab>
        <sl-tab slot="nav" panel="terms">Terms and Conditions</sl-tab>

        <sl-tab-panel name="english">
          <sl-card>
            ${text}
            <!-- The build this client was built with (#411): a release's version, or a dev
                 deploy's commit sha as it is, the same value the server's version gate reads. -->
            <p class="app-version">Version ${appVersion()}</p>
          </sl-card>
        </sl-tab-panel>
        <sl-tab-panel name="terms">
          <sl-card> ${terms} </sl-card>
        </sl-tab-panel>
      </sl-tab-group>
    `;
  }
}
